import { render, staticRenderFns } from "./InterventionQuestion.vue?vue&type=template&id=6c640bf3&scoped=true"
import script from "./InterventionQuestion.vue?vue&type=script&scoped=true&lang=js"
export * from "./InterventionQuestion.vue?vue&type=script&scoped=true&lang=js"
import style0 from "./InterventionQuestion.vue?vue&type=style&index=0&id=6c640bf3&prod&scoped=true&lang=css"
import style1 from "./InterventionQuestion.vue?vue&type=style&index=1&id=6c640bf3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c640bf3",
  null
  
)

export default component.exports